module.exports = __webpack_public_path__ + "static/img/cha5.6cce465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha5.png
// module id = HOpA
// module chunks = 1